import { getResponseErrorMessage } from 'apis/incentivio-api.util';
import { useState } from 'react';
import { useDispatch } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { passwordlessOAuthVerifyStartAsync } from 'redux/user/user.actions';

export const usePasswordlessOAuthVerification = () => {
  const dispatch = useDispatch();
  const history = useHistory();
  const [error, setError] = useState();

  const passwordlessOAuthVerify = async (code, method, identifier) => {
    setError(undefined);
    const result = await dispatch(
      passwordlessOAuthVerifyStartAsync({ code, method, identifier }),
    );
    if (!result.data) {
      setError(
        getResponseErrorMessage(result) ??
          result?.response?.data?.error_description,
      );
      return;
    }
    if (!result.data.is_new_user) {
      history.push('/');
    }
  };

  return { passwordlessOAuthVerify, passwordlessOAuthError: error };
};
